import React from 'react';
import { VideoWrapper, VideoFrame, VideoChildrenContainer } from './styles';

export const Video: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<IVideo>>
> = ({
  src,
  children,
  hideWhenNotInView = true,
  height = '450px',
  inview = 0,
}) => {
  if (inview === 0 && hideWhenNotInView) {
    return null;
  }

  return (
    <VideoWrapper className="pj-ui-carousel-video" style={{ height }}>
      <VideoFrame src={src} title={src} />
      <VideoChildrenContainer className="pj-ui-carousel-video--children">
        {children}
      </VideoChildrenContainer>
    </VideoWrapper>
  );
};

interface IVideo {
  src: string;
  hideWhenNotInView?: boolean;
  height?: string;
  inview?: number;
}
